import styled from '@emotion/styled';
import Status_Icon from '@assets/svg/status.svg';
import User_Icon from '@assets/svg/new-user.svg';
import Tooltip from '@components/Tooltips/Tooltip';
import { useI18n } from '@i18n/useI18n';
import { useStore } from '@store/appStore';
import { ReactElement, useRef, useState } from 'react';
import HaveNote from '../HaveNote';

const Container = styled.div<{swipe?:boolean, fullDay?:boolean}>`
  display: flex;
  justify-content: end;
  gap:6px;
  height: ${(props) => (props.swipe ? '30px' : '20px')};
  min-width: 20px;
  position: ${(props) => (props.fullDay ? 'relative' : 'absolute')};
  top:${(props) => (props.swipe ? '18px' : props.fullDay ? 'unset' :'-4px')};
  right:${(props) => (props.swipe ? '18px' : props.fullDay ? 'unset' :'-4px')};
  z-index: 10;
  margin-left: ${props => props.fullDay?"auto":"unset"};
`;

const StatusContent = styled.div<{lonely?:boolean, swipe?:boolean}>`
  margin-right: ${props => props.lonely?"8px":"unset"};
  height:100%;
  aspect-ratio: 0.8 / 1;
  z-index: 10;

  > div {
    height:100%;
    display: flex;
    justify-content: center;
    align-items: center;

    svg{
      transform:${(props) => (props.swipe ? ' scale(1.6)' : ' unset')};
    }
  }
  
`;

interface IProps {
  note:any;
  reason?:any;
}

const SelfCheckIcon = styled.div<{lonely?:boolean, swipe?:boolean, iconColor?:number}>`
  background:#fff;
  border:${props => props.swipe?"3px":"2px"} solid #AAAAAA;
  border-radius: 3px;
  margin-right: ${props => props.lonely?"8px":"unset"};
  height:${props => props.swipe?"26px":"18px"};
  aspect-ratio: 1 / 1;
  z-index: 10;

  > div {
    height:100%;
    display: flex;
    justify-content: center;
    align-items: center;

    svg{
      height: 80%;
      path{
        fill:${props => props.iconColor === 1?"#2A848E":props.iconColor === 2?"#FED425":"#FA505E"};
      }
    }
  }
  
`;

interface IProps {
  note:any;
  reason?:any;
  swipe?:boolean;
  children?:ReactElement;
}

export const StatusBar = (props: IProps) => {
  const { settings,wondeTags } = useStore();
  const i18n = useI18n();

  const getCount = () => {
    let count = 0;
    if(settings.STUDENTNOTEHIDDEN === false && props.note.show)count = count +1;
    return count
  }

  const getTag = () => {
    let tags = []

    if (props.reason.type === 1) {                
      tags = wondeTags?.present.map(t => {
          return {tag_id: t.id, name: "(" + t.code + ") " + (t.short_name?t.short_name:t.description), html_color: "2A848E"}
      })
      tags = [{tag_id: -1, name: "Present", html_color: "2A848E"}].concat(tags)
      }
      else if(props.reason.type === 2){
        tags = wondeTags?.absent.map(t => {
              return {tag_id: t.id, name: "(" + t.code + ") " + (t.short_name?t.short_name:t.description), html_color: "fb4856"}
          })
      }
      else if(props.reason.type === 3){                
        tags = wondeTags?.late.map(t => {
              return {tag_id: t.id, name: "(" + t.code + ") " + (t.short_name?t.short_name:t.description), html_color: "ffd112"}
          })
      }


        let t = tags?.find(t => t.tag_id == props.reason.tag_ids)
        if(t)return t.name        
        else return ""
    }  

  return (
    <Container swipe={props.note.swipeView} fullDay={props.note.fullDayView}>

      {props?.children}

      {props.reason?.type !== -1 && props.reason?.tag_ids && props.reason?.tag_ids.length > 0?
      <StatusContent swipe={props.note.swipeView} lonely={getCount() === 0}>
        <Tooltip offsetY={-6} content={getTag()}>
          <Status_Icon />
        </Tooltip>
      </StatusContent>:null}

      {settings.STUDENTNOTEHIDDEN?null:
        <HaveNote swipeView={props.note.swipeView} interact={props.note.interact} id={props.note.id} show={props.note.show} notecount={props.note.notecount} />
      }
    </Container>
  );
};

export default StatusBar;
